import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import ComponentMetricsBoundary from '@/components/ComponentMetricsBoundary/ComponentMetricsBoundary'
import EmailSignUp from '@/components/EmailSignUp'
import FAQ from '@/components/FAQ'
import FlyPriceDrop from '@/components/FlyPriceDrop'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import LinksWidget from '@/components/SkyMondeSeo/LinksWidget'
import FlightsTripActivity from '@/components/TripActivity/FlightsTripActivity/FlightsTripActivity'
import useGetMostRecentFlightSearch from '@/components/TripActivity/FlightsTripActivity/useGetMostRecentFlightSearch'
import useBootstrapData from '@/hooks/useBootstrapData'
import { isCollectionOfIArticleType } from '@/shared-utils/content-model-type-guards'
import { useContentfulWithPredicate } from '@pcln/contentful-components'
import { Container } from 'pcln-design-system'

function Content() {
  const mostRecentFlightSearchData = useGetMostRecentFlightSearch()
  const { skymondeSEO } = useBootstrapData()
  const articles = useContentfulWithPredicate('articles', isCollectionOfIArticleType)

  return (
    <Container size='xl' mb={5}>
      {mostRecentFlightSearchData.length > 0 && (
        <ComponentMetricsBoundary componentId='FlightsTripActivity'>
          <FlightsTripActivity mostRecentFlightSearchData={mostRecentFlightSearchData} />
        </ComponentMetricsBoundary>
      )}
      <FlyPriceDrop />
      <LayoutComponentWrapper topGap>
        <ComponentMetricsBoundary componentId='EmailSignUp'>
          <EmailSignUp appCode='DESKTOP' sourceId='LANDING_AIR' />
        </ComponentMetricsBoundary>
        <AdContent>
          <AdBox type='primary'>
            <div data-testid='flight-ad-1' id='div-gpt-ad-1510165758104-0' />
          </AdBox>
          <AdBox type='secondary'>
            <div data-testid='flight-ad-2' id='div-gpt-ad-1510169021467-0' />
          </AdBox>
          <AdBox type='tertiary'>
            <div data-testid='flight-ad-3' id='div-gpt-ad-1510169161509-0' />
          </AdBox>
        </AdContent>
        <AppDownloadWrapper />
        <AdBanner>
          <div data-testid='flight-ad-4' id='div-gpt-ad-1510169283152-0' />
        </AdBanner>
        {articles?.items?.length ? <FAQ articles={articles} /> : null}
        {skymondeSEO && (
          <ComponentMetricsBoundary componentId='LinksWidget'>
            <LinksWidget data={skymondeSEO} />
          </ComponentMetricsBoundary>
        )}
      </LayoutComponentWrapper>
    </Container>
  )
}
export default Content
